<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Card" });
import "tailwindcss/tailwind.css";
export let style = "solid";
export let size = "lg";
export let css = "";
export let color = "light";
</script>

<div class = { `s8-card s8-${ style } s8-${ size } s8-${ color } ${ css }` }>
    <slot>Hello World</slot>
</div>

<style>

    div.s8-card {
            margin-bottom: 1.5rem;
}

        div.s8-card.s8-sm {
            margin-bottom: 0px;
            border-radius: 0.5rem;
            padding: 0.25rem;
}

        div.s8-card.s8-lg {
            border-radius: 1rem;
            padding: 1.5rem;
}

        div.s8-card.s8-md {
            border-radius: 0.5rem;
            padding: 0.625rem;
}

        div.s8-card.s8-solid {
            background-color: rgba(255, 255, 255, 1);
            --tw-shadow: 0px 1px 1px 0px rgba(39, 39, 17, 0.08);
            --tw-shadow-colored: 0px 1px 1px 0px var(--tw-shadow-color);
            box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

        div.s8-card.s8-ghost {
            background-color: rgba(255, 255, 255, 1);
            box-shadow: inset 0 1px 1px 0 rgba(39,39,17,0.06);
}

        div.s8-card.s8-outline {
            border-width: 1px;
            border-color: rgba(212, 211, 209, 1);
}

        div.s8-card.s8-outline.s8-primary {
            border-color: rgba(199, 218, 207, 1);
}

        div.s8-card.s8-outline.s8-secondary {
            border-color: rgba(250, 234, 230, 1);
}

        div.s8-card.s8-outline.s8-tertiary {
            border-color: rgba(219, 243, 246, 1);
}

        div.s8-card.s8-outline.s8-quaternary {
            border-color: rgba(243, 241, 248, 1);
}

        div.s8-card.s8-outline.s8-warning {
                border: 1px solid #EFC923;
            }

        div.s8-card.s8-solid.s8-primary, div.s8-card.s8-ghost.s8-primary {
            background-color: rgba(199, 218, 207, 1);
}

        div.s8-card.s8-solid.s8-secondary, div.s8-card.s8-ghost.s8-secondary {
            background-color: rgba(250, 234, 230, 1);
}

        div.s8-card.s8-solid.s8-tertiary, div.s8-card.s8-ghost.s8-tertiary {
            background-color: rgba(219, 243, 246, 1);
}

        div.s8-card.s8-solid.s8-quaternary, div.s8-card.s8-ghost.s8-quaternary {
            background-color: rgba(243, 241, 248, 1);
}

        div.s8-card.s8-solid.s8-warning, div.s8-card.s8-ghost.s8-warning {
                background-color: rgba(239, 201, 35, 0.2);
            }

        div.s8-card.s8-ghost.s8-light {
                background-color: #f7f7f6;
            }</style>